"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import { useEffect, useState } from "react"

import { Text } from "@jobteaser/spark/components/Text/Text"

import { DATE_FORMATS, getDate, getRemainingTime } from "@/modules/dates/dates"

type JobAdCardTimeProps = {
  date: string | Date
  locale: I18nLocale
}

export const JobAdCardTime: FunctionComponent<JobAdCardTimeProps> = ({ date, locale }) => {
  const [time, setTime] = useState(
    getDate({ date: new Date(date), dateFormat: DATE_FORMATS.FULL_DATETIME, locale, timeZone: "Europe/Paris" })
  )

  useEffect(() => {
    const remainingTime = getRemainingTime({
      date,
      locale,
      reverse: true,
      timeZone: "Europe/Paris",
    })

    if (remainingTime) {
      setTime(remainingTime)
    }
  }, [locale, date])

  return (
    <Text variant="caption1" weight="regular" as="time" suppressHydrationWarning>
      {time}
    </Text>
  )
}
